import App from "@/App.tsx";
import { setRootHTMLStyles } from "@/styles/helpers/setRootHTMLStyles.tsx";
import { StrictMode } from "react";
import rdpStyles from "react-day-picker/style.css?inline";
import ReactDOM from "react-dom/client";
import styles from "./index.scss?inline";

setRootHTMLStyles();

const hostDiv = document.getElementById("bookingEngine");
if (hostDiv) {
  const shadow = hostDiv.attachShadow({ mode: "open" });

  // Inject styles into shadow root
  const styleEl = document.createElement("style");
  styleEl.textContent = rdpStyles + styles;
  shadow.appendChild(styleEl);

  // Create React mount point inside shadow
  const container = document.createElement("div");
  container.id = "bookingEngineRoot";
  shadow.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(
    <StrictMode>
      <App rootDiv={hostDiv as HTMLDivElement} shadowRoot={shadow} />
    </StrictMode>,
  );

  // HMR support for dev mode
  if (import.meta.hot) {
    import.meta.hot.accept("./index.scss?inline", (newModule) => {
      if (newModule) styleEl.textContent = newModule.default;
    });
  }
}
